export default __webpack_public_path__ + "static/media/careers.0a6e4a07.svg";